<template>
  <div class="module-regions-list" v-if="regionsItem">
    <div
      class="module-regions-list__title"
      :class="regionVisible ? 'arrow-top' : 'arrow-bottom'"
      @mouseenter="toggleRegionVisible"
      @click="toggleRegionVisible"
    >
      zmień
    </div>
    <div
      class="module-regions-list__content"
      v-if="regionVisible"
      :class="{ active: regionVisible }"
      @mouseleave="toggleRegionVisible"
    >
      <div
        v-for="(item, index) in regionsItemOrder"
        :key="index"
        class="module-regions-list__item"
        :class="{ active: index === activeRegion }"
        @click="changeRegion(item, index)"
      >
        {{ item.title }}
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const activeRegion = ref()
const emit = defineEmits(['selectedRegion'])
const changeRegion = (item, index) => {
  activeRegion.value = index
  // Po wybraniu regionu chowamy menu
  toggleRegionVisible()
  // Wstawiamy wybrany region do headline
  emit('selectedRegion', item)
}

const regionVisible = ref(false)
const toggleRegionVisible = () => {
  regionVisible.value = !regionVisible.value
}

const regionsItemOrder = computed(() => props.regionsItem.slice(1))

const props = defineProps({
  regionsItem: {
    type: Array,
    default: () => []
  }
})
</script>

<style scoped lang="scss">
@import '@/assets/scss/components/modules/module-regions-list.scss';
</style>
